import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Flower2, LogOut } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

const startLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/studio";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-border">
      <div className="max-w-7xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <Flower2 className="w-6 h-6 text-primary" />
          <span className="font-serif-display text-2xl font-semibold tracking-tight">Bloom &amp; Vow</span>
        </Link>

        <div className="flex items-center gap-2 sm:gap-5">
          <Link
            to="/studio"
            data-testid="nav-studio"
            className={`text-sm font-medium hover:text-primary transition-colors ${location.pathname === "/studio" ? "text-primary" : "text-muted-foreground"}`}
          >
            Studio
          </Link>
          {user && (
            <Link
              to="/my-bouquets"
              data-testid="nav-my-bouquets"
              className={`text-sm font-medium hover:text-primary transition-colors ${location.pathname === "/my-bouquets" ? "text-primary" : "text-muted-foreground"}`}
            >
              My Bouquets
            </Link>
          )}
          {user?.is_admin && (
            <Link
              to="/orders"
              data-testid="nav-orders"
              className={`text-sm font-medium hover:text-primary transition-colors ${location.pathname === "/orders" ? "text-primary" : "text-muted-foreground"}`}
            >
              Quote Requests
            </Link>
          )}
          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button data-testid="nav-avatar" className="outline-none">
                  <Avatar className="w-9 h-9 border border-border">
                    <AvatarImage src={user.picture} alt={user.name} />
                    <AvatarFallback className="bg-primary text-primary-foreground text-sm">
                      {user.name?.[0] || "U"}
                    </AvatarFallback>
                  </Avatar>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-48">
                <div className="px-2 py-1.5 text-sm">
                  <p className="font-medium truncate">{user.name}</p>
                  <p className="text-xs text-muted-foreground truncate">{user.email}</p>
                </div>
                <DropdownMenuItem onClick={handleLogout} data-testid="nav-logout">
                  <LogOut className="w-4 h-4 mr-2" /> Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <button
              onClick={startLogin}
              data-testid="nav-login-btn"
              className="rounded-full px-5 py-2.5 text-sm font-medium bg-primary text-primary-foreground hover:bg-[#2C4631] transition-all shadow-sm hover:shadow-md"
            >
              Sign in
            </button>
          )}
        </div>
      </div>
    </nav>
  );
}

export { startLogin };
